import React from "react";
import { motion } from "framer-motion";
import {
  FaJs,
  FaJava,
  FaReact,
  FaNodeJs,
  FaGitAlt,
  FaGithub,
  FaGitlab,
  FaJira,
  FaProjectDiagram,
  FaChartLine,
  FaComments,
  FaCode,
} from "react-icons/fa";
import {
  SiTypescript,
  SiAngular,
  SiNextdotjs,
  SiSpring,
  SiRedux,
  SiPrime,
  SiAntdesign,
  SiPostgresql,
  SiOracle,
  SiVisualstudiocode,
  SiIntellijidea,
  SiReactivex,
} from "react-icons/si";

const iconComponents = {
  SiTypescript,
  SiAngular,
  SiNextdotjs,
  SiSpring,
  SiRedux,
  SiPrime,
  SiAntdesign,
  SiPostgresql,
  SiOracle,
  SiVisualstudiocode,
  SiIntellijidea,
  SiReactivex,
  FaJs,
  FaJava,
  FaReact,
  FaNodeJs,
  FaGitAlt,
  FaGithub,
  FaGitlab,
  FaJira,
  FaProjectDiagram,
  FaChartLine,
  FaComments,
  FaCode,
};

const Skills = ({ skills }) => {
  const renderSkillItem = (skill) => {
    const IconComponent = iconComponents[skill.icon];
    return (
      <div key={skill.name} className="skill-tag">
        {IconComponent && <IconComponent className="skill-icon" />}
        <span>{skill.name}</span>
      </div>
    );
  };

  return (
    <section id="skills" className="skills-section">
      <div className="container">
        <motion.h2
          className="section-title"
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          viewport={{ once: true }}
        >
          My <span>Skills</span>
        </motion.h2>

        <div className="skills-container">
          <motion.div
            className="skills-intro"
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            viewport={{ once: true }}
          >
            <h3>Technical Expertise Across the Stack</h3>
            <p>
              With extensive experience in both frontend and backend
              development, I've mastered a wide range of technologies to deliver
              robust, scalable solutions.
            </p>
          </motion.div>

          <div className="skills-categories">
            <motion.div
              className="skills-category"
              initial={{ opacity: 0, x: -50 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.5 }}
              viewport={{ once: true }}
            >
              <h4 className="category-title">Languages</h4>
              <div className="skills-list">
                {skills.languages.map(renderSkillItem)}
              </div>
            </motion.div>

            <motion.div
              className="skills-category"
              initial={{ opacity: 0, x: 50 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.5 }}
              viewport={{ once: true }}
            >
              <h4 className="category-title">Frameworks</h4>
              <div className="skills-list">
                {skills.frameworks.map(renderSkillItem)}
              </div>
            </motion.div>

            <motion.div
              className="skills-category"
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5 }}
              viewport={{ once: true }}
            >
              <h4 className="category-title">Libraries</h4>
              <div className="skills-list">
                {skills.libraries.map(renderSkillItem)}
              </div>
            </motion.div>

            <motion.div
              className="skills-category"
              initial={{ opacity: 0, x: -50 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.5 }}
              viewport={{ once: true }}
            >
              <h4 className="category-title">Tools</h4>
              <div className="skills-list">
                {skills.tools.map(renderSkillItem)}
              </div>
            </motion.div>

            <motion.div
              className="skills-category"
              initial={{ opacity: 0, x: 50 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.5 }}
              viewport={{ once: true }}
            >
              <h4 className="category-title">Platforms</h4>
              <div className="skills-list">
                {skills.platforms.map(renderSkillItem)}
              </div>
            </motion.div>

            <motion.div
              className="skills-category"
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5 }}
              viewport={{ once: true }}
            >
              <h4 className="category-title">Soft Skills</h4>
              <div className="skills-list">
                {skills.softSkills.map(renderSkillItem)}
              </div>
            </motion.div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Skills;
